import React from 'react';
import { Badge, useApi } from '@axiom/ui';
import { CandidateProfileIssuesUtils } from '@axiom/utils';
import type { Candidate } from '@axiom/validation';

import { CandidateProfileIssuesApi } from '../../api/candidate-profile-issues-api';
import { CandidateApi } from '../../api/candidate-api';
import { CandidateOpportunitiesLegacyApi } from '../../api/candidate-opportunities-legacy-api';
import { CandidateExperienceApi } from '../../api/candidate-experience-api';
import { ProfileCompletionUtil } from '../../utils/profile-completion-util';

export const ProfileIssuesCounter: React.FC<{
  candidateId: Candidate['id'];
}> = ({ candidateId }) => {
  const [
    { data: candidate },
    { data: candidateOpportunities },
    { data: profileIssues },
    { data: experiences },
  ] = useApi(
    CandidateApi.readCandidate(candidateId),
    CandidateOpportunitiesLegacyApi.readOpportunitiesByCandidateId(candidateId),
    CandidateProfileIssuesApi.readCandidateProfileIssues(candidateId),
    CandidateExperienceApi.readExperiences(candidateId)
  );
  const actionNeededItems = ProfileCompletionUtil.getActionNeededItems(
    profileIssues.issues,
    experiences,
    candidate.degrees
  );

  return CandidateProfileIssuesUtils.shouldShowActionNeededList(
    candidate,
    candidateOpportunities,
    profileIssues.issues
  ) ? (
    <Badge background="orange" name="profile-issues-count">
      {actionNeededItems.length}
    </Badge>
  ) : null;
};
